import {
  MESSAGE_LOADER_MUTATIONS_ENUM,
} from './message-loader.eum';

export const messageLoaderMutations = {
  [MESSAGE_LOADER_MUTATIONS_ENUM.SET_LOADING_MESSAGE](state, payload) {
    state.loadingMessage = payload;
  },
};
